import React from 'react';
import styles from './PlaceSelectorDetails.module.scss';
import {Grid} from '@material-ui/core';
import CustomTextField from 'gui/components/customTextField';
import {FieldProps} from "formik";
import {When} from "react-if";
import PlaceImagePicker
  from 'gui/components/editors/hotelEditor/components/hotelDetailsForm/components/hotelDetails/components/placeImagePicker/PlaceImagePicker';

export interface IPlaceSelectorProps extends FieldProps<any> {
  placeKey?: string;
  imagesPickKey?: string;
}

const PlaceSelectorDetails = (props: IPlaceSelectorProps) => {
  return (<When condition={props.form.values[props.placeKey] !== undefined}>
    {() => <Grid container spacing={2} className={styles.placeDetails}>
      <Grid item
            sm={!!(props.form.values[props.placeKey].loading || props.form.values[props.placeKey] && props.form.values[props.placeKey].country) || "auto"}>
        <CustomTextField
          label="מדינה"
          value={props.form.values[props.placeKey] ? props.form.values[props.placeKey].country : ""}
          disabled={props.form.values[props.placeKey] === undefined}
          readOnly
          loading={props.form.values[props.placeKey].loading}
        />
      </Grid>
      <Grid item
            sm={!!(props.form.values[props.placeKey].loading || props.form.values[props.placeKey] && props.form.values[props.placeKey].city) || "auto"}>
        <CustomTextField
          label="עיר"
          value={props.form.values[props.placeKey] ? props.form.values[props.placeKey].city : ""}
          disabled={props.form.values[props.placeKey] === undefined}
          readOnly
          loading={props.form.values[props.placeKey].loading}
        />
      </Grid>
      <Grid item
            sm={!!(props.form.values[props.placeKey].loading || props.form.values[props.placeKey] && props.form.values[props.placeKey].street) || "auto"}>
        <CustomTextField
          label="רחוב"
          value={props.form.values[props.placeKey] ? props.form.values[props.placeKey].street : ""}
          disabled={props.form.values[props.placeKey] === undefined}
          readOnly
          loading={props.form.values[props.placeKey].loading}
        />
      </Grid>
      <Grid item
            sm={!!(props.form.values[props.placeKey].loading || props.form.values[props.placeKey] && props.form.values[props.placeKey].rating) || "auto"}>
        <CustomTextField
          label="ציון (GOOGLE)"
          value={props.form.values[props.placeKey] ? props.form.values[props.placeKey].rating : ""}
          disabled={props.form.values[props.placeKey] === undefined}
          readOnly
          loading={props.form.values[props.placeKey].loading}
        />
      </Grid>
      <Grid item xs={12}>
        <PlaceImagePicker
          key={JSON.stringify(props.form.values[props.placeKey] ? props.form.values[props.placeKey].photos : [])}
          values={props.form.values as any}
          setFieldValue={props.form.setFieldValue}
          submitCount={props.form.submitCount}
          errors={props.form.errors}
          placeKey={props.placeKey}
          imagesPickKey={props.imagesPickKey}
        />
      </Grid>
    </Grid>
    }
  </When>);
};

PlaceSelectorDetails.defaultProps = {
  placeKey: 'place',
  imagesPickKey: 'imagePick',
};

export default React.memo(PlaceSelectorDetails);
